const equationReducer = (state = '', action) => {
  switch(action.type) {
    case 'equate':
      return state = action.payload.replaceAll('+', '%2b') //encode + sign for API
    default:
      return state
  }
}

export default equationReducer